/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AssetManagementContactHistoryListResponse } from '../models/asset-management-contact-history-list-response';
import { assetManagementControllerC } from '../fn/asset-management/asset-management-controller-c';
import { AssetManagementControllerC$Params } from '../fn/asset-management/asset-management-controller-c';
import { assetManagementControllerCreate } from '../fn/asset-management/asset-management-controller-create';
import { AssetManagementControllerCreate$Params } from '../fn/asset-management/asset-management-controller-create';
import { assetManagementControllerDelete } from '../fn/asset-management/asset-management-controller-delete';
import { AssetManagementControllerDelete$Params } from '../fn/asset-management/asset-management-controller-delete';
import { assetManagementControllerDownloadImportTemplate } from '../fn/asset-management/asset-management-controller-download-import-template';
import { AssetManagementControllerDownloadImportTemplate$Params } from '../fn/asset-management/asset-management-controller-download-import-template';
import { assetManagementControllerFindAllAssetManagementContactHistory } from '../fn/asset-management/asset-management-controller-find-all-asset-management-contact-history';
import { AssetManagementControllerFindAllAssetManagementContactHistory$Params } from '../fn/asset-management/asset-management-controller-find-all-asset-management-contact-history';
import { assetManagementControllerFindAllAssetManagementDataHistory } from '../fn/asset-management/asset-management-controller-find-all-asset-management-data-history';
import { AssetManagementControllerFindAllAssetManagementDataHistory$Params } from '../fn/asset-management/asset-management-controller-find-all-asset-management-data-history';
import { assetManagementControllerFindAllAssetManagementMovementHistory } from '../fn/asset-management/asset-management-controller-find-all-asset-management-movement-history';
import { AssetManagementControllerFindAllAssetManagementMovementHistory$Params } from '../fn/asset-management/asset-management-controller-find-all-asset-management-movement-history';
import { assetManagementControllerFindAllAssetManagementReplacementHistory } from '../fn/asset-management/asset-management-controller-find-all-asset-management-replacement-history';
import { AssetManagementControllerFindAllAssetManagementReplacementHistory$Params } from '../fn/asset-management/asset-management-controller-find-all-asset-management-replacement-history';
import { assetManagementControllerFindOne } from '../fn/asset-management/asset-management-controller-find-one';
import { AssetManagementControllerFindOne$Params } from '../fn/asset-management/asset-management-controller-find-one';
import { assetManagementControllerGetAll } from '../fn/asset-management/asset-management-controller-get-all';
import { AssetManagementControllerGetAll$Params } from '../fn/asset-management/asset-management-controller-get-all';
import { assetManagementControllerGetImportJob } from '../fn/asset-management/asset-management-controller-get-import-job';
import { AssetManagementControllerGetImportJob$Params } from '../fn/asset-management/asset-management-controller-get-import-job';
import { assetManagementControllerImportAssets } from '../fn/asset-management/asset-management-controller-import-assets';
import { AssetManagementControllerImportAssets$Params } from '../fn/asset-management/asset-management-controller-import-assets';
import { assetManagementControllerReactivateAssetManagement } from '../fn/asset-management/asset-management-controller-reactivate-asset-management';
import { AssetManagementControllerReactivateAssetManagement$Params } from '../fn/asset-management/asset-management-controller-reactivate-asset-management';
import { assetManagementControllerReplacementAssetManagement } from '../fn/asset-management/asset-management-controller-replacement-asset-management';
import { AssetManagementControllerReplacementAssetManagement$Params } from '../fn/asset-management/asset-management-controller-replacement-asset-management';
import { assetManagementControllerReplacementOfTheReplacement } from '../fn/asset-management/asset-management-controller-replacement-of-the-replacement';
import { AssetManagementControllerReplacementOfTheReplacement$Params } from '../fn/asset-management/asset-management-controller-replacement-of-the-replacement';
import { assetManagementControllerUpdate } from '../fn/asset-management/asset-management-controller-update';
import { AssetManagementControllerUpdate$Params } from '../fn/asset-management/asset-management-controller-update';
import { assetManagementControllerUpdateAssetManagementContact } from '../fn/asset-management/asset-management-controller-update-asset-management-contact';
import { AssetManagementControllerUpdateAssetManagementContact$Params } from '../fn/asset-management/asset-management-controller-update-asset-management-contact';
import { AssetManagementDataHistoryItemListResponse } from '../models/asset-management-data-history-item-list-response';
import { AssetManagementItem } from '../models/asset-management-item';
import { AssetManagementListResponse } from '../models/asset-management-list-response';
import { AssetManagementMovementHistoryListResponse } from '../models/asset-management-movement-history-list-response';
import { AssetManagementReplacementHistoryListResponse } from '../models/asset-management-replacement-history-list-response';
import { BaseResponse } from '../models/base-response';

@Injectable({ providedIn: 'root' })
export class AssetManagementService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `assetManagementControllerDownloadImportTemplate()` */
  static readonly AssetManagementControllerDownloadImportTemplatePath = '/asset-management/import/template';

  /**
   * Scarica il template Excel per l'import asset.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerDownloadImportTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerDownloadImportTemplate$Response(params?: AssetManagementControllerDownloadImportTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return assetManagementControllerDownloadImportTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * Scarica il template Excel per l'import asset.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerDownloadImportTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerDownloadImportTemplate(params?: AssetManagementControllerDownloadImportTemplate$Params, context?: HttpContext): Observable<void> {
    return this.assetManagementControllerDownloadImportTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerImportAssets()` */
  static readonly AssetManagementControllerImportAssetsPath = '/asset-management/import';

  /**
   * Import asset da file Excel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerImportAssets()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  assetManagementControllerImportAssets$Response(params: AssetManagementControllerImportAssets$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return assetManagementControllerImportAssets(this.http, this.rootUrl, params, context);
  }

  /**
   * Import asset da file Excel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerImportAssets$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  assetManagementControllerImportAssets(params: AssetManagementControllerImportAssets$Params, context?: HttpContext): Observable<void> {
    return this.assetManagementControllerImportAssets$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerGetImportJob()` */
  static readonly AssetManagementControllerGetImportJobPath = '/asset-management/import/{job_id}';

  /**
   * Stato di avanzamento e risultato di un import asset.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerGetImportJob()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerGetImportJob$Response(params: AssetManagementControllerGetImportJob$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return assetManagementControllerGetImportJob(this.http, this.rootUrl, params, context);
  }

  /**
   * Stato di avanzamento e risultato di un import asset.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerGetImportJob$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerGetImportJob(params: AssetManagementControllerGetImportJob$Params, context?: HttpContext): Observable<void> {
    return this.assetManagementControllerGetImportJob$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerGetAll()` */
  static readonly AssetManagementControllerGetAllPath = '/asset-management';

  /**
   * Restituisce l'elenco degli asset management.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerGetAll$Response(params: AssetManagementControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementListResponse;
}>> {
    return assetManagementControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli asset management.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerGetAll(params: AssetManagementControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementListResponse;
}> {
    return this.assetManagementControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementListResponse;
}>): BaseResponse & {
'data'?: AssetManagementListResponse;
} => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerCreate()` */
  static readonly AssetManagementControllerCreatePath = '/asset-management';

  /**
   * Crea un asset management.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assetManagementControllerCreate$Response(params: AssetManagementControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>> {
    return assetManagementControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un asset management.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assetManagementControllerCreate(params: AssetManagementControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementItem;
}> {
    return this.assetManagementControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>): BaseResponse & {
'data'?: AssetManagementItem;
} => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerReplacementAssetManagement()` */
  static readonly AssetManagementControllerReplacementAssetManagementPath = '/asset-management/replace-asset-management';

  /**
   * Sostituisce un asset.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerReplacementAssetManagement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assetManagementControllerReplacementAssetManagement$Response(params: AssetManagementControllerReplacementAssetManagement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>> {
    return assetManagementControllerReplacementAssetManagement(this.http, this.rootUrl, params, context);
  }

  /**
   * Sostituisce un asset.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerReplacementAssetManagement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assetManagementControllerReplacementAssetManagement(params: AssetManagementControllerReplacementAssetManagement$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementItem;
}> {
    return this.assetManagementControllerReplacementAssetManagement$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>): BaseResponse & {
'data'?: AssetManagementItem;
} => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerReplacementOfTheReplacement()` */
  static readonly AssetManagementControllerReplacementOfTheReplacementPath = '/asset-management/replacement-of-the-replacement';

  /**
   * Sostituisce un asset che è già un sostituto di un altro.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerReplacementOfTheReplacement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assetManagementControllerReplacementOfTheReplacement$Response(params: AssetManagementControllerReplacementOfTheReplacement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>> {
    return assetManagementControllerReplacementOfTheReplacement(this.http, this.rootUrl, params, context);
  }

  /**
   * Sostituisce un asset che è già un sostituto di un altro.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerReplacementOfTheReplacement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assetManagementControllerReplacementOfTheReplacement(params: AssetManagementControllerReplacementOfTheReplacement$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementItem;
}> {
    return this.assetManagementControllerReplacementOfTheReplacement$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>): BaseResponse & {
'data'?: AssetManagementItem;
} => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerReactivateAssetManagement()` */
  static readonly AssetManagementControllerReactivateAssetManagementPath = '/asset-management/{id}/reactivate';

  /**
   * Riattiva un asset management.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerReactivateAssetManagement()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerReactivateAssetManagement$Response(params: AssetManagementControllerReactivateAssetManagement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>> {
    return assetManagementControllerReactivateAssetManagement(this.http, this.rootUrl, params, context);
  }

  /**
   * Riattiva un asset management.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerReactivateAssetManagement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerReactivateAssetManagement(params: AssetManagementControllerReactivateAssetManagement$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementItem;
}> {
    return this.assetManagementControllerReactivateAssetManagement$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>): BaseResponse & {
'data'?: AssetManagementItem;
} => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerUpdateAssetManagementContact()` */
  static readonly AssetManagementControllerUpdateAssetManagementContactPath = '/asset-management/{id}/updateContact';

  /**
   * Aggiorna il contatto associato all'asset.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerUpdateAssetManagementContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assetManagementControllerUpdateAssetManagementContact$Response(params: AssetManagementControllerUpdateAssetManagementContact$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>> {
    return assetManagementControllerUpdateAssetManagementContact(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiorna il contatto associato all'asset.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerUpdateAssetManagementContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assetManagementControllerUpdateAssetManagementContact(params: AssetManagementControllerUpdateAssetManagementContact$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementItem;
}> {
    return this.assetManagementControllerUpdateAssetManagementContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>): BaseResponse & {
'data'?: AssetManagementItem;
} => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerFindAllAssetManagementMovementHistory()` */
  static readonly AssetManagementControllerFindAllAssetManagementMovementHistoryPath = '/asset-management/{id}/movement-history';

  /**
   * Restituisce lo storico dei movimenti di un asset management.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerFindAllAssetManagementMovementHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerFindAllAssetManagementMovementHistory$Response(params: AssetManagementControllerFindAllAssetManagementMovementHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementMovementHistoryListResponse;
}>> {
    return assetManagementControllerFindAllAssetManagementMovementHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce lo storico dei movimenti di un asset management.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerFindAllAssetManagementMovementHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerFindAllAssetManagementMovementHistory(params: AssetManagementControllerFindAllAssetManagementMovementHistory$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementMovementHistoryListResponse;
}> {
    return this.assetManagementControllerFindAllAssetManagementMovementHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementMovementHistoryListResponse;
}>): BaseResponse & {
'data'?: AssetManagementMovementHistoryListResponse;
} => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerFindAllAssetManagementReplacementHistory()` */
  static readonly AssetManagementControllerFindAllAssetManagementReplacementHistoryPath = '/asset-management/{id}/replacement-history';

  /**
   * Restituisce lo storico delle sostituzioni di un asset management.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerFindAllAssetManagementReplacementHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerFindAllAssetManagementReplacementHistory$Response(params: AssetManagementControllerFindAllAssetManagementReplacementHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementReplacementHistoryListResponse;
}>> {
    return assetManagementControllerFindAllAssetManagementReplacementHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce lo storico delle sostituzioni di un asset management.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerFindAllAssetManagementReplacementHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerFindAllAssetManagementReplacementHistory(params: AssetManagementControllerFindAllAssetManagementReplacementHistory$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementReplacementHistoryListResponse;
}> {
    return this.assetManagementControllerFindAllAssetManagementReplacementHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementReplacementHistoryListResponse;
}>): BaseResponse & {
'data'?: AssetManagementReplacementHistoryListResponse;
} => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerC()` */
  static readonly AssetManagementControllerCPath = '/asset-management/{agreement_id}/agreement-assets';

  /**
   * Restituisce gli asset di una commessa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerC()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerC$Response(params: AssetManagementControllerC$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementListResponse;
}>> {
    return assetManagementControllerC(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce gli asset di una commessa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerC$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerC(params: AssetManagementControllerC$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementListResponse;
}> {
    return this.assetManagementControllerC$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementListResponse;
}>): BaseResponse & {
'data'?: AssetManagementListResponse;
} => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerFindAllAssetManagementContactHistory()` */
  static readonly AssetManagementControllerFindAllAssetManagementContactHistoryPath = '/asset-management/{id}/contact-history';

  /**
   * Restituisce lo storico dei contatti di un asset management.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerFindAllAssetManagementContactHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerFindAllAssetManagementContactHistory$Response(params: AssetManagementControllerFindAllAssetManagementContactHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementContactHistoryListResponse;
}>> {
    return assetManagementControllerFindAllAssetManagementContactHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce lo storico dei contatti di un asset management.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerFindAllAssetManagementContactHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerFindAllAssetManagementContactHistory(params: AssetManagementControllerFindAllAssetManagementContactHistory$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementContactHistoryListResponse;
}> {
    return this.assetManagementControllerFindAllAssetManagementContactHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementContactHistoryListResponse;
}>): BaseResponse & {
'data'?: AssetManagementContactHistoryListResponse;
} => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerFindAllAssetManagementDataHistory()` */
  static readonly AssetManagementControllerFindAllAssetManagementDataHistoryPath = '/asset-management/{id}/data-history';

  /**
   * Restituisce lo storico delle modifiche di un asset management.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerFindAllAssetManagementDataHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerFindAllAssetManagementDataHistory$Response(params: AssetManagementControllerFindAllAssetManagementDataHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementDataHistoryItemListResponse;
}>> {
    return assetManagementControllerFindAllAssetManagementDataHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce lo storico delle modifiche di un asset management.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerFindAllAssetManagementDataHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerFindAllAssetManagementDataHistory(params: AssetManagementControllerFindAllAssetManagementDataHistory$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementDataHistoryItemListResponse;
}> {
    return this.assetManagementControllerFindAllAssetManagementDataHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementDataHistoryItemListResponse;
}>): BaseResponse & {
'data'?: AssetManagementDataHistoryItemListResponse;
} => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerFindOne()` */
  static readonly AssetManagementControllerFindOnePath = '/asset-management/{id}';

  /**
   * Restituisce un asset management.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerFindOne$Response(params: AssetManagementControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>> {
    return assetManagementControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un asset management.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerFindOne(params: AssetManagementControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementItem;
}> {
    return this.assetManagementControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>): BaseResponse & {
'data'?: AssetManagementItem;
} => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerDelete()` */
  static readonly AssetManagementControllerDeletePath = '/asset-management/{id}';

  /**
   * Elimina un asset management.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerDelete$Response(params: AssetManagementControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>> {
    return assetManagementControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un asset management.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assetManagementControllerDelete(params: AssetManagementControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementItem;
}> {
    return this.assetManagementControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>): BaseResponse & {
'data'?: AssetManagementItem;
} => r.body)
    );
  }

  /** Path part for operation `assetManagementControllerUpdate()` */
  static readonly AssetManagementControllerUpdatePath = '/asset-management/{id}';

  /**
   * Modifica un asset management.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assetManagementControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assetManagementControllerUpdate$Response(params: AssetManagementControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>> {
    return assetManagementControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un asset management.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assetManagementControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assetManagementControllerUpdate(params: AssetManagementControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementItem;
}> {
    return this.assetManagementControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>): BaseResponse & {
'data'?: AssetManagementItem;
} => r.body)
    );
  }

}
